<template>
    <div>
        <Dropdown
            :options="list_countries"
            :disabled="false"
            name="country"
            :maxItem="10"
            placeholder="Please select a country">
        </Dropdown>
    </div>
</template>

<script>
    import Dropdown from 'vue-simple-search-dropdown';
    Vue.component('Dropdown', Dropdown);

    export default {
        props: [
            'countries',
        ],

        data() {
            return {
                list_countries:[],

            }
        },

        mounted() {
            this.countries.forEach((country, index) =>
            {
                this.list_countries.push({id:index, name:country.name});
                //this.list_countries.push({country);
            });
        },

        methods: {


        }
    }


</script>